var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarReview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    "data-name": "Layer 3",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.9506,16.98184l-.25925-1.95537h0L3.49409,13.46a2.40746,2.40746,0,0,1,0-2.92225L4.69135,8.97312h0L4.9524,7.01775a2.40722,2.40722,0,0,1,2.06684-2.067l1.95342-.25927h0L10.539,3.49413a2.407,2.407,0,0,1,2.922,0l1.56633,1.19735h0l1.95522.26108a2.409,2.409,0,0,1,2.06684,2.067l.25925,1.95357h0l1.19726,1.56465a2.40746,2.40746,0,0,1,0,2.92225l-1.19726,1.56645h0l-.26106,1.95537a2.409,2.409,0,0,1-2.06683,2.0688l-1.95342.25747h0L13.461,20.50726a2.41236,2.41236,0,0,1-2.922,0L8.97266,19.30811h0L7.01744,19.047A2.40363,2.40363,0,0,1,4.9506,16.98184Z",
    fill: "none",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.10322,8.0857a1,1,0,0,1,1.79356,0l.50879,1.03141a.99994.99994,0,0,0,.75295.54718l1.13813.16542A1,1,0,0,1,15.851,11.5351l-.8239.80361a1,1,0,0,0-.28735.8849l.1944,1.13328a1,1,0,0,1-1.45077,1.05421l-1.0182-.53515a1,1,0,0,0-.93042,0l-1.0182.53515a1,1,0,0,1-1.45077-1.05421l.1944-1.13328a1,1,0,0,0-.28735-.8849L8.149,11.5351a1,1,0,0,1,.55438-1.70539l1.13813-.16542a.99994.99994,0,0,0,.75295-.54718Z",
    fill: "none",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarReview);
export default __webpack_public_path__ + "static/media/star-review.fa78097f8018e95de59e089b195165a4.svg";
export { ForwardRef as ReactComponent };